export enum ValidationMessages {
  Required = 0,
  Invalid,
  Minimum,
  Maximum,
}

export enum IdTypes {
  ID = 0,
  Passport = 1,
}

export enum AssetTypes {
  REAL_ESTATE = 1,
  LOAN = 2,
}

export enum ExperienceType {
  equity,
  stocks,
  bondsCertificates,
  investments,
  participations,
  subordinatedLoans,
}

export enum ExperienceLevel {
  none = "none",
  low = "low",
  medium = "medium",
  high = "high",
}

export const ForEach = (
  enumName: string,
  createElement: (x: any) => any,
): Array<any> => {
  switch (enumName) {
    case 'ExperienceType':
      let index = 0
      return Array.from(new Array(Object.keys(ExperienceType).length / 2), _ =>
        createElement(index++),
      )
    default:
      return []
  }
}
